import { Face, FaceRetouchingOff } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React, { PropsWithChildren } from 'react';

type Props = {
  isGuest: boolean;
};

const Guest: React.FC<PropsWithChildren<Props>> = ({ isGuest }) => {
  if (isGuest) {
    return (
      <Tooltip title="Guest" placement="left">
        <FaceRetouchingOff style={{ color: '#ffc107' }} />
      </Tooltip>
    );
  }

  return <Face style={{ color: '#28a745' }} />;
};

export default Guest;
